import React, { useState } from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import Audioplayer from './player';
import Viewer3D from '../../3dview/viewer';

const Details3D = ({ objects = [], close }) => {

    const [activeObject, setActiveObject] = useState(objects[0]);
    const [active3d, setActive3d] = useState(false)
    return (
        <>
            <div className="grid-flow-row grid grid-cols-3 grid-rows-1">
                <div className="col-span-1">
                    <Splide className="rounded-lg overflow-hidden" options={{ type: "loop", drag: false }} aria-label="My Favorite Images" onActive={(e) => {
                        console.log(e.index);
                        setActiveObject(objects[e.index])
                    }}>
                        {objects?.map((e, i) => {
                            return (
                                <SplideSlide key={i} className='bg-slate-500'>
                                    <Viewer3D object={e.object} />
                                </SplideSlide>
                            )
                        })}

                    </Splide>
                </div>
                <div className="col-span-2 ps-5">

                    <div className="flex flex-row w-full items-center justify-between">
                        <div className="text-2xl font-bold">
                            {activeObject.title}
                        </div>
                        <div>
                            {close}
                        </div>
                    </div>
                    <div className='flex flex-col justify-end h-full pb-9'>

                        <div className='self-start h-full'>
                            {activeObject.desc}
                        </div>
                        <div>
                            <div className='bg-slate-800 px-3 py-1 font-semibold rounded-lg flex items-center gap-2 w-fit' onClick={() => {

                            }}>
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" class="bi bi-badge-3d-fill" viewBox="0 0 16 16">
                                    <path d="M10.157 5.968h-.844v4.06h.844c1.116 0 1.621-.667 1.621-2.02 0-1.354-.51-2.04-1.621-2.04" />
                                    <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm5.184 4.368c.646 0 1.055.378 1.06.9.008.537-.427.919-1.086.919-.598-.004-1.037-.325-1.068-.756H3c.03.914.791 1.688 2.153 1.688 1.24 0 2.285-.66 2.272-1.798-.013-.953-.747-1.38-1.292-1.432v-.062c.44-.07 1.125-.527 1.108-1.375-.013-.906-.8-1.57-2.053-1.565-1.31.005-2.043.734-2.074 1.67h1.103c.022-.391.383-.751.936-.751.532 0 .928.33.928.813.004.479-.383.835-.928.835h-.632v.914zM8.126 11h2.189C12.125 11 13 9.893 13 7.985c0-1.894-.861-2.984-2.685-2.984H8.126z" />
                                </svg></div>
                                <div>
                                    Obróć z pomocą technologii 3D
                                </div>
                            </div>
                        </div>
                        {activeObject.voice === null ? <>
                        </> :
                            <div>
                                <div className='mt-5 mb-2 font-semibold'>
                                    Posłuchaj o medalu
                                </div>
                                <div className='rounded-md overflow-hidden'>
                                    <Audioplayer url={activeObject.voice}></Audioplayer>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {active3d ?
                <div className='fixed top-0 left-0 w-screen h-screen'>

                </div>
                : <></>}
        </>
    )
}

export default Details3D